/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Departments {
    "use strict";

    export class DepartmentsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public isViewedFromLocation = false;
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            rootScope: ng.IRootScopeService,
            protected $scope: ng.IScope
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.department;
            this.sectionTemplatePath = "app/plugins/departments/sectionViews/";

            this.buildCrudSecurityKeys(this.securityKeys.DATA_DEPARTMENT_TAB_MAIN);
            this.entityType = 'Department';
            this.$scope.$watch( ()=> {
                this.isLoading ? this.busyService.start() : this.busyService.stop();
            });
        }

        initializeSections(): void {
            
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_DEPARTMENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(
                    new MainSection(
                        0,
                        "SECTION_DEPARTMENT_MAIN",
                        "main.html",
                        true,
                        false,
                        this.appSettings.API_ENDPOINTS.department,
                        "",
                        this.loggingService,
                        this.dataService,
                        this.identityService,
                        Meevo.Model.NounEnum.DepartmentMain,
                        null,
                        this.securityKeys.DATA_DEPARTMENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }


        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.isViewedFromLocation = model.atLocationName !== model.ownedByLocationName;
        }

        delete(): void {
            let vm = this;
            // Do not allow CO-owned items to be deleted in a location
            if (vm.isCoItemInLocation || vm.isViewedFromLocation) {
                vm.modalService.alert("MESSAGE_CANNOT_DELETE_CO_ITEM", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            if (this.canDelete) {
                this.modalService.warning("MESSAGE_DELETE_CONFIRMATION_DEPARTMENT", 0, false, {
                    showCancelButton: true,
                    okButtonContentKey: 'LABEL_YES',
                    cancelButtonContentKey: 'LABEL_NO',
                    cancelButtonHotKey: 'MODAL_NO_BUTTON',
                    okButtonHotKey: 'MODAL_YES_BUTTON'
                }).then((response: boolean) => {
                        vm.loadingInProgress = true;
                        // Patch model object state to Deleted
                        vm.dataService.objectStatePatch(vm.baseEndpoint,
                            vm.itemId,
                            vm.selectedSection.model.entityVersion,
                            <number>Model.ObjectStateEnum.Deleted,
                            vm.asLocationId,
                            this.selectedSection.sectionEndpoint)
                            .then((data) => {
                                if (data) {
                                    vm.selectedSection.model = data;
                                    if (vm.identityService.current().isSingleLocation) {
                                        vm.selectedSection.model.businessTypeDetail = null;
                                        vm.selectedSection.model.businessTypeId = null;
                                    }
                                    vm.selectedSection.sectionModelRetrieved();
                                    vm.loggingService.trace(`Delete saved.`);
                                }
                                this.postDelete();
                            })
                            .finally(() => {
                                vm.loadingInProgress = false
                            });
                    });

            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
        }

        /*undelete(): void {
            let vm = this;
            if (this.canUndelete) {
                vm.loadingInProgress = true;
                // Patch model object state to Active
                vm.dataService.objectStatePatch(this.baseEndpoint,
                    vm.itemId,
                    vm.selectedSection.model.entityVersion,
                    <number>Model.ObjectStateEnum.Active,
                    vm.asLocationId,
                    this.selectedSection.sectionEndpoint)
                    .then((data) => {
                        if (data) {
                            vm.selectedSection.model = data;
                            if (vm.identityService.current().isSingleLocation) {
                                vm.selectedSection.model.businessTypeDetail = null;
                                vm.selectedSection.model.businessTypeId = null;
                            }
                            vm.selectedSection.sectionModelRetrieved();
                            vm.loggingService.trace(`Undelete saved.`);
                        }
                    })
                    .finally(() => {
                        vm.loadingInProgress = false
                    });
            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
        }*/

        save(): angular.IPromise<any> {
            let deletedItem;
            if (this.selectedSection.model['employeeIds'] && this.selectedSection.model['employeeIds'].length > 0) {
                deletedItem = this.selectedSection['backup'] && this.selectedSection['backup']['employeeIds'] && this.selectedSection['backup']['employeeIds'].find((elem) => {
                    let diff = this.selectedSection.model['employeeIds'].find((emp) => elem.id === emp.id);
                    if (!diff) {
                        return true;
                    }
                });
            }

            if (deletedItem) {
                this.busyService.stop();
                return this.modalService.confirm("MESSAGE_DEPARTMENT_DELETE_EMPLOYEE").then((res) => {
                    if (res) {
                        return super.save();
                    }
                });
            } else {
                return super.save();
            }
        }

        onBusinessTypeChange(): void {
            if (this.selectedSection instanceof MainSection) {
                let mainSection = <MainSection>this.selectedSection;
                mainSection.getDepartment();
            }
        }
    }
}